import logoPill from '../../assets/logo-pill.svg'
import { GOALS, reachGoal } from '../../lib/metrika'

// Якоря на секции-разделы. Порядок повторяет расположение секций на странице:
// Stats (#product) → HowItWorks (#how-it-works) → Why (#benefits) → Dashboard (#dashboard).
const NAV_LINKS = [
  { href: '#product', label: 'О продукте' },
  { href: '#how-it-works', label: 'Как работает' },
  { href: '#benefits', label: 'Преимущества' },
  { href: '#dashboard', label: 'О кабинете' },
]

// Header — Figma node 2055:2459. Тёмный pill `bg-[#303030]`,
// border `#505050`, rounded-[16px], padding 5px. Sticky-режим:
// прилипает к верху viewport, центрирован по горизонтали.
// Адаптив: на узких скрываем nav, остаются только лого и CTA.
//
// Вертикальные поля решают две задачи сразу.
// `mt-` больше липкого смещения `top-3`: в потоке header стоит на y=0, и без
// него sticky при нулевом скролле сам сдвигал pill вниз, приклеивая к кромке.
// Отрицательный `mb-` убирает место, которое header занимал бы в потоке, —
// иначе он отталкивал герой вниз и над карточкой оставалась белая полоса.
// В сумме pill лежит на первом экране, пересекая его верхний край.
export function Header() {
  return (
    <header
      className="sticky top-3 z-50 mx-auto mt-4 -mb-7 w-fit max-w-[calc(100%-1rem)] px-2 sm:top-4 sm:mt-5 sm:-mb-8"
      style={{ pointerEvents: 'auto' }}
    >
      <nav
        className="flex items-center gap-0 rounded-[16px] border border-[#505050] bg-[#303030] p-[5px]"
        style={{
          boxShadow:
            '0px 20px 25px -5px rgba(0,0,0,0.1), 0px 8px 10px -6px rgba(0,0,0,0.1)',
        }}
      >
        {/* Логотип — круг 36×36 */}
        <a
          href="/"
          aria-label="RIS — на главную"
          className="block shrink-0 pr-2"
        >
          <img src={logoPill} alt="RIS" width={36} height={36} className="size-9 rounded-[10px]" />
        </a>

        {/* Nav-links — белые, Inter 16, gap 24, padding 32 по бокам.
            На узких скрываем чтобы pill не растягивался. */}
        <ul className="hidden items-center gap-6 px-8 md:flex">
          {NAV_LINKS.map(({ href, label }) => (
            <li key={href}>
              <a
                href={href}
                onClick={() => reachGoal(GOALS.navClick, { item: label })}
                className="font-sans whitespace-nowrap text-[16px] font-normal leading-4 text-white transition hover:opacity-60"
                style={{ textShadow: '0px 1px 2px rgba(0,0,0,0.07)' }}
              >
                {label}
              </a>
            </li>
          ))}
        </ul>

        {/* CTA — оранжевый gradient, rounded-[8px].
            Текст белый по решению дизайна. Контраст с этим оранжевым — 2.39
            сверху градиента и 3.25 снизу при норме 4.5; тёмный #041527 давал
            бы 7.50 и 5.52. Если когда-нибудь понадобится закрыть доступность
            без потери белого текста — затемнять придётся сам градиент. */}
        <a
          href="https://lk.ris.promo/auth/register"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => reachGoal(GOALS.signupClick, { place: 'шапка' })}
          className="ml-2 inline-flex items-center justify-center rounded-[8px] px-3 py-2.5 text-[14px] font-semibold leading-4 text-[#fcfcfc] transition duration-300 hover:brightness-125 active:brightness-90 sm:text-[16px] md:ml-0"
          style={{
            backgroundImage: 'linear-gradient(180deg, #ff8418 0%, #ff4c1b 100%)',
          }}
        >
          Запустить кампанию
        </a>
      </nav>
    </header>
  )
}
